import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Box } from 'edenred-ui';
import { BenefitTypeIcon } from '../../BenefitTypeIcon/BenefitTypeIcon';

type SectionWrapperProps = {
  benefitName: string;
  subtitle?: string;
};

const SectionWrapper = ({
  benefitName,
  subtitle,
  children
}: PropsWithChildren<SectionWrapperProps>) => {
  const { t } = useTranslation();
  const {
    gray10,
    gray30,
    primaryFrontColor,
    sizeExtraLarge,
    fontSemiBold,
    sizeSmall,
    fontRegularBold
  } = useTheme();
  const name = t(
    `components.manage_benefits.new.benefits.${benefitName.toLowerCase()}`
  );

  return (
    <Box
      border={`1px solid ${gray10}`}
      padding={3}
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Box display="flex" justifyContent="space-between" gap={1}>
        <Box display="flex" alignItems="center" gap={1}>
          <Box
            color={primaryFrontColor}
            fontSize={sizeExtraLarge}
            fontWeight={fontSemiBold}
          >
            {name}
          </Box>
          <Box
            width={32}
            height={32}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <BenefitTypeIcon benefit={benefitName?.toLowerCase()} />
          </Box>
        </Box>
        {subtitle && (
          <Box fontSize={sizeSmall} fontWeight={fontRegularBold} color={gray30}>
            {subtitle}
          </Box>
        )}
      </Box>
      {children}
    </Box>
  );
};

export { SectionWrapper };
